export const UPDATED_FOCUS = 'updated_focus';
export const CLEARED_FOCUS = 'cleared_focus';
